export class WidgetLocation {
  private readonly MovementName = 'sentiments.movement.status';
  private readonly LeftMovementName = 'sentiments.position.left';
  private readonly TopMovementName = 'sentiments.position.top';
  private readonly RollOutStatusName = 'sentiments.rollOutStatus';

  private _hasWidgetMoved: boolean | null = false;
  private _left: number | null;
  private _top: number | null;
  private _rollOutStatus = false;

  constructor() {
    this._hasWidgetMoved = window.sessionStorage.getItem(this.MovementName) === 'true' || false;
    const left = window.sessionStorage.getItem(this.LeftMovementName);
    const top = window.sessionStorage.getItem(this.TopMovementName);
    const rollStatus = window.sessionStorage.getItem(this.RollOutStatusName);

    if (left) {
      this._left = JSON.parse(left);
    }

    if (top) {
      this._top = JSON.parse(top);
    }

    if (rollStatus) {
      this._rollOutStatus = JSON.parse(rollStatus);
    }
  }

  get hasWidgetMoved(): boolean {
    return this._hasWidgetMoved;
  }

  set hasWidgetMoved(value: boolean | null) {
    this._hasWidgetMoved = value;
    if (value === null) {
      window.sessionStorage.removeItem(this.MovementName);
    } else {
      window.sessionStorage.setItem(this.MovementName, value.toString());
    }
  }

  get left(): number | null {
    return this._left;
  }

  set left(value: number | null) {
    this._left = value;
    if (value === null) {
      window.sessionStorage.removeItem(this.LeftMovementName);
    } else {
      window.sessionStorage.setItem(this.LeftMovementName, value.toString());
    }
  }

  get top(): number | null {
    return this._top;
  }

  set top(value: number | null) {
    this._top = value;
    if (value === null) {
      window.sessionStorage.removeItem(this.TopMovementName);
    } else {
      window.sessionStorage.setItem(this.TopMovementName, value.toString());
    }
  }

  get rollOutStatus(): boolean {
    return this._rollOutStatus;
  }

  set rollOutStatus(value: boolean) {
    this._rollOutStatus = value;
    window.sessionStorage.setItem(this.RollOutStatusName, value.toString());
  }
}
